import $ from "jquery";

export default class ScrollMenu {
  init() {
    var lastId,
      topMenu = $(".scroll-list"),
      topMenuHeight = 250,
      menuItems = topMenu.find("a"),
      scrollItems = menuItems.map(function () {
        let href = $(this).attr("href");
        let href_data = href.split('#');

        var item = $('#' + href_data[href_data.length - 1]);
        if (item.length) {
          return item;
        }
      });

    function calculateItemActive() {
      var fromTop = $(window).scrollTop() + topMenuHeight;

      var cur = scrollItems.map(function () {
        if ($(this).offset().top < fromTop)
          return this;
      });
      cur = cur[cur.length - 1];
      var id = cur && cur.length ? cur[0].id : "";

      if (lastId !== id) {
        lastId = id;

        menuItems.removeClass('c-jump-mark-navigation__link--clicked')
          .end().filter("[href='#" + id + "']").addClass('c-jump-mark-navigation__link--clicked');

        menuItems.parent().removeClass("scroll-list-active")
          .end().filter("[href='#" + id + "']").parent().addClass("scroll-list-active");
      }
    }

    function stickyMobile(stickyHeight) {
      if (window.pageYOffset >= (stickyHeight.top / 300)) {
        topSticky.addClass("sticky");
      } else {
        topSticky.removeClass("sticky");
      }
    }

    let topSticky = $(".sticky-mobile");
    if(topSticky.length > 0) {
      let stickyHeight = topSticky.offset();
      stickyMobile(stickyHeight);

      $(window).scroll(function () {
        stickyMobile(stickyHeight);
      });
    }

    $(window).scroll(function () {
      calculateItemActive();
    });

    function hideScrollMenu() {
      $(".scroll-list-mobile").click(function() {
        $(this).toggleClass('open-list');
        $(this).children().removeClass('scroll-list-active');
      });
      $(".scroll-list-mobile li").click(function() {
        $(".scroll-list-mobile li").each(function() {
          $(this).removeClass('scroll-list-active');
        });
        $(this).addClass('scroll-list-active');
      });

    }

    hideScrollMenu();
  }
}



// WEBPACK FOOTER //
// ./scripts/components/scroll-menu.js